import { render, staticRenderFns } from "./SingleImage.vue?vue&type=template&id=2d9966cb"
import script from "./SingleImage.vue?vue&type=script&lang=js"
export * from "./SingleImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports